import { render } from "./MSProfilePanel.vue?vue&type=template&id=c0e18aaa&scoped=true&ts=true"
import script from "./MSProfilePanel.vue?vue&type=script&lang=ts"
export * from "./MSProfilePanel.vue?vue&type=script&lang=ts"

import "./MSProfilePanel.vue?vue&type=style&index=0&id=c0e18aaa&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0e18aaa"]])

export default __exports__